


import {Slider} from '../index'

const Topbox = () => {
    return (
        <>
            <section>


                <div className='columns   '>

                    <div className='column is-12'>
                        <Slider/>

                    </div>



                </div>
            </section>

        </>
    )
}

export default Topbox;